import React from 'react';
import { log } from '../DebugLogger';

// Energy type to icon mapping
const ENERGY_ICONS = {
  Colorless: '/energy/colorless.png',
  Darkness: '/energy/darkness.png',
  Dragon: '/energy/dragon.png',
  Fighting: '/energy/fighting.png',
  Fire: '/energy/fire.png',
  Grass: '/energy/grass.png',
  Lightning: '/energy/lightning.png',
  Metal: '/energy/metal.png',
  Psychic: '/energy/psychic.png',
  Water: '/energy/water.png'
} as const;

export type EnergyType = keyof typeof ENERGY_ICONS;

interface EnergyIconProps {
  type: string;
  size?: number;
  className?: string;
  title?: string;
}

export function EnergyIcon({ type, size = 16, className = '', title }: EnergyIconProps) {
  const iconPath = ENERGY_ICONS[type as EnergyType];
  if (!iconPath) {
    log(`Invalid energy type: ${type}`);
    return null;
  }
  
  return (
    <img 
      src={iconPath} 
      alt={`${type} energy`}
      title={title || `${type} energy`}
      width={size}
      height={size}
      className={`inline-block ${className}`}
      loading="eager"
      decoding="sync"
      onError={(e) => {
        log(`Failed to load energy icon: ${type}`);
        const img = e.target as HTMLImageElement;
        img.style.display = 'none';
      }}
    />
  );
}